import portrait from "../assets/portrait.jpeg";
import '../App.css';

export default function About() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-center text-3xl font-bold mb-4">Welcome to my Website!</h1>

      <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
        <img
          className="profile-pic"
          src={portrait}
          alt="Connor Chartier"
        />

        <div className="flex-1">
          <p className="mb-4">
            Hello! I'm <strong>Connor</strong>, a software engineer passionate about creativity,
            overcoming challenges, and developing purposful software. I also enjoy writing, reading, chess, philosophy, music, and gaming!
            <br />
            My hobbies include:
            <ul className="list-disc pl-6 text-lg">
              <li>Reading - I am currently reading <em>The Handmaid's Tale</em> by Margaret Atwood and <em>Project Hail Mary</em> by Andy Weir</li>
              <li>Writing - I enjoy writing daily</li>
              <li>Music - I am currently listening to <em>Deadbeat</em> by Tame Impala</li>
              <li>Strategy Games - I play <em>Catan</em>, <em>Risk</em>, and chess (despite being terrible at it)</li>
            </ul>
          </p>
          <h2 className="text-2xl font-semibold mt-6 mb-2">Education</h2>
          <p className="mb-4">
            <strong>B.S.</strong> in Computer Science from Worcester Polytechnic Institute in the Class of 2025.
            <br />
            <strong>Minor</strong> in Interactive Media and Game Development.
          </p>
          <h2 className="text-2xl font-semibold mt-6 mb-2">Research</h2>

          <div className="mb-8">
            <h3 className="text-lg font-medium mt-4 mb-1">Analyzing the Impact of Frametime Spikes on Navigation-Based Tasks in 2D Platformers</h3>
            <p className="text-gray-300 mb-1">
              <strong>Sponsor:</strong> NVIDIA Esports Research Team
              <br />
              <strong>Advisor:</strong> Professor Mark Claypool (Worcester Polytechnic Institute)
              <br />
              <strong>Team Members:</strong> Nathan Anderson and Jonathan Asher
            </p>
            <p className="mb-2">
              - Provided weekly progress reports to the project advisor and sponsor, a research team from NVIDIA Corporation
              <br />
              - Modified an existing game code base to introduce frame spikes during critical moments in gameplay
              <br />
              - Conducted a user study where participants played the game and provided feedback via an interview and survey
              <br />
              - Analyzed player performance data and concluded the most impactful frame spike thresholds for each game task
            </p>
            <a
              href="https://digital.wpi.edu/show/s7526h89m"
              className="text-blue-500 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit Project Website
            </a>
            <br />
            <a
              href="/MQP_Report.pdf"
              className="text-blue-500 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Research Paper
            </a>
            <br />
            <a
              href="/MQP_Poster.pdf"
              className="text-blue-500 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Poster
            </a>
          </div>

          <div className="mb-8">
            <h3 className="text-lg font-medium mt-4 mb-1">Informing a Potential Central Bank Digital Currency (CBDC) Pilot Study in New Zealand</h3>
            <p className="text-gray-300 mb-1">
              <strong>Sponsor:</strong> Professor Jennifer Ferriera (Victoria University of Wellington)
              <br />
              <strong>Advisor:</strong> Professor John Smith (WPI Humanities Dept.)
              <br />
              <strong>Team Members:</strong> Michaela Cluett, Sukriti Kushwaha, and Humza Qureshi
            </p>
            <p className="mb-2">
              - Collaborated on an interdisciplinary team of four to lead 5 interviews with scholars and banking experts, 25
              interviews with local businesses, 50 public interviews, and field-tested an online survey in Wellington, NZ
              <br />
              - Identified opportunities for the Reserve Bank of New Zealand to inspire public CBDC usage and
              recommended strategies to further increase and evaluate CBDC awareness moving forward
            </p>
            <a
              href="https://digital.wpi.edu/show/zk51vn16x"
              className="text-blue-500 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit Project Website
            </a>
            <br />
            <a
              href="/IQP_Report.pdf"
              className="text-blue-500 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Research Paper
            </a>
          </div>
        </div>
      </div>

    </div>
  );
}

